/* Project List Page will be imported from here */
import ProjectList from "./projects-list";

export default ProjectList;
